module.exports = __webpack_public_path__ + "img/avatar7.8aac3265.png";